export default "__VITE_ASSET__ebXgThNp__"